import { memo, useState } from 'react';
import { useCooperativeId } from 'hooks';
import { useHistory } from 'react-router-dom';
import { TaskTodo } from 'models';
import services from 'services';

import { TaskWidget, WidgetContainer } from 'components';

interface LocalState {
  tasks: TaskTodo[] | null;
  loading: boolean;
  error: boolean;
}

interface Props {
  defaultTasks: TaskTodo[];
}

const TaskWidgetContainer: React.FC<Props> = ({ defaultTasks }) => {
  const coopId = useCooperativeId();
  const history = useHistory();
  const [state, setState] = useState<LocalState>(() => ({
    tasks: defaultTasks,
    loading: false,
    error: false,
  }));

  const fetchTasks = async (success?: () => void) => {
    try {
      setState((prevState) => ({
        ...prevState,
        loading: success ? prevState.loading : true,
        error: false,
      }));

      const tasks: TaskTodo[] | null = (
        await services.get(`/api/user/cooperatives/${coopId}/widget/task`)
      ).data?.Data?.Tasks;

      setState((prevState) => ({
        ...prevState,
        loading: success ? prevState.loading : false,
        tasks: tasks || null,
      }));

      if (success) success();
    } catch (err) {
      console.error(err);

      setState((prevState) => ({ ...prevState, loading: false, error: true }));
    }
  };

  const forwardToTodoPage = () => history.push('/todo');

  if (!state.tasks) return null;

  return (
    <WidgetContainer
      error={state.error}
      loading={state.loading}
      title={'Kaikki tehtävät'}
      themeColor="darkBlue"
      action={forwardToTodoPage}
    >
      <TaskWidget tasks={state.tasks} fetchTasks={fetchTasks} />
    </WidgetContainer>
  );
};

export default memo(TaskWidgetContainer);
